import 'hammerjs'

import { enableProdMode, provideZoneChangeDetection } from '@angular/core'
import { platformBrowser } from '@angular/platform-browser'
import { AppModule } from './app/app.module'
import { environment } from './environments/environment'

import * as Sentry from '@sentry/angular'
import { baseConfig } from './app/core/config/base-config'
import { version } from './assets/version'

fetch('/assets/configuration.json?v=1')
    .then((res) => res.json())
    .then((config) => {
        baseConfig.next(config)

        if (config.environment !== 'Local' || (config.environment === 'Local' && config.enableSentryOnDev)) {
            Sentry.init({
                dsn: config.sentry_dsn,
                environment: config.environment,
                tracesSampleRate: config.sentry_tracesSampleRate,
                replaysSessionSampleRate: config.sentry_replaysSessionSampleRate,
                replaysOnErrorSampleRate: config.sentry_replaysOnErrorSampleRate,
                release: version
            })
        }

        if (environment.production) {
            enableProdMode()
        }

        platformBrowser()
            .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
            .catch((err) => console.error(err))
    })
